import React from 'react';
import Hero from '../../components/Hero/Hero';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      <Hero />
      
      {/* Additional content sections can be added here */}
      <section className="home__content">
        <div className="container">
          <div className="home__intro">
            <h2>Welcome to Golden Pour</h2>
            <p>
              Experience Melbourne's finest selection of Victorian craft beers in a 
              relaxed, premium atmosphere. Our 12 rotating taps feature the best 
              local breweries, ensuring there's always something fresh to discover.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;